import React from "react";

import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "antd/es/form";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { useIntl } from "react-intl";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";
import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";
import { ColorCircle, ColorDropdown } from "@mapmycustomers/ui";

import isClosedStage from "@app/util/isClosedStage";

import styles from "./StageColor.module.scss";

interface Props {
  onChange?: () => void;
  stage: Stage;
  value?: AnyColor;
}

const StageColor: React.FC<Props> = ({ onChange, stage, value }) => {
  const intl = useIntl();
  const { status } = Form.Item.useStatus();
  return (
    <ColorDropdown
      className={cn(styles.colorDropdown, {
        [styles.disabled]: isClosedStage(stage),
        [styles.errorColor]: status === "error",
      })}
      colorPanelProps={{
        showColorSpace: true,
        showInput: true,
        showNamedColors: true,
      }}
      disabled={isClosedStage(stage)}
      onChange={onChange}
      value={value}
    >
      {status === "error" ? (
        <div>
          <Tooltip
            title={intl.formatMessage({
              id: "deals.manageFunnelModal.stageColor.validation”",
              defaultMessage: "Stages cannot have same color",
              description: "Label for stages cannot have same color",
            })}
          >
            <div className={styles.errorIcon}>
              <FontAwesomeIcon icon={faInfoCircle} />
            </div>
          </Tooltip>
          <ColorCircle value={value} />
        </div>
      ) : undefined}
    </ColorDropdown>
  );
};

export default StageColor;
